import type { FC, ReactElement } from 'react';

import { DateFormatter } from '../../../formatters/DateFormatter';
import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useGameStateSlice } from '../../../store/slices/game/selectors';
import { Button, ButtonVariant } from '../../controls/button/Button';

import { BlockingModalContent } from './BlockingModalContent';

export const TableClosedConnected: FC = (): ReactElement => {
  const redirectToLobby = useRedirectToLobbyCallbackConnected();

  const openTime = useGameStateSlice.table()?.openTime;

  const action = [<Button key="OK" tk="OK" variant={ButtonVariant.ACCENT} onClick={() => redirectToLobby()} />];

  return (
    <BlockingModalContent actions={action} title={openTime !== undefined ? <L10nText tk="TABLE_IS_CLOSED" /> : null}>
      {openTime !== undefined ? (
        <>
          <L10nText tk="LOBBY_OPEN_TIME" />
          <h2 style={{ margin: 'var(--core-spacing-tiny) 0' }}>
            {DateFormatter.toLocaleTimeString(openTime, 'en-gb', {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </h2>
          {DateFormatter.toLocaleDateString(openTime, 'en-gb')}
        </>
      ) : (
        <L10nText tk="TABLE_CLOSED_ALERT" />
      )}
    </BlockingModalContent>
  );
};
